// ─── What the app is on a phone ──────────────────────────────────────────────
//
// The mobile build is deliberately a subset. Roughly forty screens in this app
// are dense, multi-column, desktop-first tools (reconciliation, payroll runs,
// masters, audit log); squeezing them into 375px would take weeks and produce
// something nobody would choose to use. So a phone gets the handful of screens
// worth having in your pocket, each designed for it, and says so plainly about
// the rest.
//
// This file is the single source of truth for that list. Adding a screen to
// mobile means adding it here and giving it a phone layout — nothing else in
// the shell needs to change.

export interface MobileTab {
  to: string;
  label: string;
  icon: string;
}

/** Bottom tab bar. Five is the practical ceiling before targets get too narrow. */
export const MOBILE_TABS: MobileTab[] = [
  { to: '/dashboard', label: 'Home', icon: '🏠' },
  { to: '/tasks', label: 'Tasks', icon: '📋' },
  { to: '/timesheets', label: 'Time', icon: '⏱️' },
  { to: '/invoices', label: 'Invoices', icon: '🧾' },
  { to: '/reimbursements', label: 'Claims', icon: '💸' },
];

/**
 * Every path reachable on a phone. Matched by prefix, so detail routes and
 * query-string deep links (/invoices?invoiceId=12) come along for free.
 *
 * /profile is here because it holds the password change and the logout — a
 * phone user must never be stuck signed in with no way out.
 */
const MOBILE_PATHS: string[] = [...MOBILE_TABS.map((t) => t.to), '/profile'];

export function isMobileRoute(pathname: string): boolean {
  return MOBILE_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

/** Tab whose section the current path belongs to, for highlighting. */
export function activeTab(pathname: string): MobileTab | undefined {
  return MOBILE_TABS.find((t) => pathname === t.to || pathname.startsWith(`${t.to}/`));
}
